<template>
<span class="Polaris-KeyboardKey">
    <slot></slot>
</span>
</template>

<script>
export default {
};
</script>


// WEBPACK FOOTER //
// src/components/PolarisKeyboardKey.vue?4af21b66